import firebaseService from "./firebaseService";
const firebaseInstance = firebaseService();

export const app = firebaseInstance
export const auth = firebaseInstance.auth()
export const firestore = firebaseInstance.firestore()
